const DarkMode = (function () {
	function toggleDarkMode(event) {
		const isDarkMode = event.target.checked;

		if (isDarkMode) {
			document.documentElement.classList.add( 'dark-mode' );
			document.documentElement.classList.remove( 'light-mode' );
		} else {
			document.documentElement.classList.remove( 'dark-mode' );
			document.documentElement.classList.add( 'light-mode' );
		}

		swapLogoImages( isDarkMode );

		localStorage.setItem( 'darkMode', isDarkMode );
	}

	function swapLogoImages(isDarkMode) {

		const logoImages = document.querySelectorAll( '.logo-swap' );

		logoImages.forEach(
			img => {
            const lightSrc = img.getAttribute( 'data-light-src' );
            const darkSrc  = img.getAttribute( 'data-dark-src' );
            img.src         = isDarkMode ? darkSrc : lightSrc;
			}
		);
	}

	function loadDarkMode() {
		const savedDarkMode  = localStorage.getItem( 'darkMode' ) === 'true';
		const darkModeToggle = document.getElementById( 'darkModeToggle' );

		if (savedDarkMode) {
			document.documentElement.classList.add( 'dark-mode' );
			darkModeToggle.checked = true;
		} else {
			darkModeToggle.checked = false;
		}

		swapLogoImages( savedDarkMode );
	}

	return {
		init: function () {
			document.getElementById( 'darkModeToggle' ).addEventListener( 'change', toggleDarkMode );
			loadDarkMode();
		}
	};
})();

export default DarkMode;